
import {
    initialState as loaderInitialState,
    createLoaderReducer
} from '../../common/client/reducers/loader';

export const initialState = {
    ...loaderInitialState
};

export function getArticleByName(state, name) {
    let articles = getArticles(state);
    return articles
        ? articles.reduce((previous, current) => {
            return (current.name === name)
                ? current
                : previous;
        }, null)
        : null;
}

export function getArticles(state) {
    return state?.data?.data?.articles;
}

export function getIsArticlesLoaded(state) {
    return (
        state.loaded &&
        !state.loading
    );
}

export default function createReducer(actionType) {
    const loaderReducer = createLoaderReducer(actionType);

    return (state = initialState, action) => {
        switch (action.type) {

            case actionType.DEFAULT:
                return {
                    ...state
                };

            case actionType.SUCCESS:
                return {
                    ...state,
                    ...loaderReducer(state, action),
                };

            default:
                return loaderReducer(state, action);
        }
    };
}
